var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "gh-menuDrop"
  }, [_c('div', {
    staticClass: "gh-description"
  }, [_vm._t("description")], 2), _c('div', {
    staticClass: "gh-content"
  }, [_vm._t("content")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };